import type { FC } from "react";
import { MouseEvent } from "react";

import { t } from "i18n/i18n";
import { EditReferenceKeys } from "i18n/i18next";
import { SquareIconButton, SquareIconButtonSize } from "mds/components/buttons/SquareIconButton";
import { PencilEditIcon } from "mds/icons";

export interface EditIconButtonProps {
  className?: string;
  onClick: () => void;
  reference: EditReferenceKeys;
  eventPrefix?: string;
  size?: SquareIconButtonSize;
}

export const ToolbarEditIconButton: FC<EditIconButtonProps> = ({
  className,
  onClick,
  reference,
  eventPrefix,
  size = "s",
}) => {
  return (
    <SquareIconButton
      className={className}
      eventName={eventPrefix ? `${eventPrefix}Rename` : undefined}
      kind="ghost"
      size={size}
      title={t("edit_delete_widget.edit", { context: reference })}
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <PencilEditIcon />
    </SquareIconButton>
  );
};
